import { render } from "./PopUpForm.vue?vue&type=template&id=a1ee7928&scoped=true"
import script from "./PopUpForm.vue?vue&type=script&lang=js"
export * from "./PopUpForm.vue?vue&type=script&lang=js"

import "./PopUpForm.vue?vue&type=style&index=0&id=a1ee7928&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1ee7928"]])

export default __exports__